export default {
	methods: {
		forceAjaxError(type) {
			// 404, 500
			// timeout
			// exception
			// error
			// static
			// nonJson

			return this.get('/dev/force-ajax-error', {
				type: type
			});
		},
	}
}
